import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { lastValueFrom, take } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FamilyDutyFeatureService {
  #http = inject(HttpClient);
  #enabled = signal(false);
  #ready = signal(false);
  #loadPromise: Promise<void> | null = null;

  readonly enabled = this.#enabled.asReadonly();
  readonly ready = this.#ready.asReadonly();

  isEnabled(): boolean {
    return this.#enabled();
  }

  async whenReady(): Promise<void> {
    if (this.#ready()) {
      return;
    }
    if (!this.#loadPromise) {
      this.#loadPromise = this.#load();
    }
    await this.#loadPromise;
  }

  async reload(): Promise<void> {
    this.#ready.set(false);
    this.#loadPromise = this.#load();
    await this.#loadPromise;
  }

  async #load(): Promise<void> {
    try {
      const flags = await lastValueFrom(
        this.#http
          .get<{ family: boolean }>(`${environment.baseUrl}/duties/feature-flags`)
          .pipe(take(1)),
      );
      this.#enabled.set(!!flags.family);
    } catch {
      this.#enabled.set(false);
    } finally {
      this.#ready.set(true);
    }
  }
}
